export const makeFormData = (payload, excludeKeys) => {
  const payloadKeys = Object.keys(payload);
  const formData = new FormData();
  for (let i = 0; i < payloadKeys.length; i++) {
    if (!excludeKeys?.includes(payloadKeys[i]))
      formData.append(payloadKeys[i], payload[payloadKeys[i]]);
  }
  return formData;
};
